/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ProcessInstanceHistoryDto } from '../../models/process-instance-history-dto';

export interface AutomatedProcessGetProcessInstanceHistory$Params {
  processInstanceId: string;
}

export function automatedProcessGetProcessInstanceHistory(http: HttpClient, rootUrl: string, params: AutomatedProcessGetProcessInstanceHistory$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ProcessInstanceHistoryDto>>> {
  const rb = new RequestBuilder(rootUrl, automatedProcessGetProcessInstanceHistory.PATH, 'get');
  if (params) {
    rb.path('processInstanceId', params.processInstanceId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ProcessInstanceHistoryDto>>;
    })
  );
}

automatedProcessGetProcessInstanceHistory.PATH = '/automated-process/process-instance/{processInstanceId}/history';